import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { Panel } from "../components/common/Panel";
import { CopyBtn, Row } from "../components/common/Detail";
import { getBlock } from "../lib/api";
import { shorten, timeAgo, fmtNum, fmtEth, CHAIN } from "../lib/format";

export default function BlockDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [block, setBlock] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    setBlock(null); setErr(false);
    getBlock(id).then(setBlock).catch(() => setErr(true));
  }, [id]);

  if (err) return <NotFound label="Block" navigate={navigate} />;
  if (!block) return <Loading />;

  return (
    <div className="fade-in" data-testid="block-detail-page">
      <div className="mb-4 flex items-center gap-3">
        <button onClick={() => navigate(-1)} className="nav-link" data-testid="back-btn"><i className="fa-solid fa-arrow-left" /></button>
        <div>
          <span className="eyebrow" style={{ color: "var(--amber)" }}>Block</span>
          <h1 className="font-display text-[24px] font-extrabold mt-1">#{fmtNum(block.number)}</h1>
        </div>
      </div>

      <div className="flex items-center gap-2 mb-4">
        <Link to={`/block/${block.number - 1}`} className="pill pill-muted" data-testid="prev-block"><i className="fa-solid fa-chevron-left" /> Prev</Link>
        <Link to={`/block/${block.number + 1}`} className="pill pill-muted" data-testid="next-block">Next <i className="fa-solid fa-chevron-right" /></Link>
      </div>

      <Panel title="Block Overview">
        <Row label="Block Height">{fmtNum(block.number)}</Row>
        <Row label="Timestamp">{timeAgo(block.timestamp)} · {new Date(block.timestamp * 1000).toUTCString()}</Row>
        <Row label="Transactions"><span className="pill pill-amber">{block.txCount} txns</span></Row>
        <Row label="Validator (Proposer)" mono><Link to={`/address/${block.miner}`} className="link-amber">{block.miner}</Link></Row>
        <Row label="Block Hash" mono>{block.hash}<CopyBtn text={block.hash} testId="copy-block-hash" /></Row>
        <Row label="Parent Hash" mono><Link to={`/block/${block.parentHash}`} className="link-amber">{block.parentHash}</Link></Row>
        <Row label="Gas Used">{fmtNum(block.gasUsed)}</Row>
        <Row label="Gas Limit">{fmtNum(block.gasLimit)}</Row>
        <Row label="Base Fee">{fmtNum(block.baseFeePerGas)} wei</Row>
        <Row label="Size">{fmtNum(block.size)} bytes</Row>
      </Panel>

      {block.transactions?.length > 0 && (
        <Panel title="Block Transactions" className="mt-5" bodyClass="overflow-auto">
          <table className="dt">
            <thead><tr><th>Tx Hash</th><th>From</th><th>To</th><th>Value</th></tr></thead>
            <tbody>
              {block.transactions.map((t) => (
                <tr key={t.hash} onClick={() => (window.location.href = `/tx/${t.hash}`)}>
                  <td><Link to={`/tx/${t.hash}`} className="link-amber mono" onClick={(e) => e.stopPropagation()}>{shorten(t.hash, 10, 8)}</Link></td>
                  <td className="mono text-[12px]" style={{ color: "var(--muted)" }}>{shorten(t.from, 6, 4)}</td>
                  <td className="mono text-[12px]" style={{ color: "var(--muted)" }}>{shorten(t.to, 6, 4)}</td>
                  <td className="mono text-[12px]">{fmtEth(t.valueEth, 4)} {CHAIN.symbol}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Panel>
      )}
    </div>
  );
}

export function Loading() {
  return <div className="text-center py-24" style={{ color: "var(--muted)" }} data-testid="loading"><i className="fa-solid fa-circle-notch fa-spin text-2xl" style={{ color: "var(--amber)" }} /><div className="mt-3">Loading…</div></div>;
}
export function NotFound({ label, navigate }) {
  return (
    <div className="text-center py-24 fade-in" data-testid="not-found">
      <i className="fa-solid fa-triangle-exclamation text-3xl" style={{ color: "var(--amber)" }} />
      <div className="mt-4 font-display text-lg">{label} not found</div>
      <button onClick={() => navigate("/")} className="btn-amber mt-6">Back to Dashboard</button>
    </div>
  );
}
